import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const CGUPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6 text-muted-foreground hover:text-foreground"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: '#1E40AF' }}>
          Conditions Générales d'Utilisation
        </h1>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">1. Objet</h2>
            <p>Les présentes CGU définissent les modalités et conditions d'utilisation des services proposés par DevisFast, ainsi que les droits et obligations des parties. En accédant au Service, l'utilisateur reconnaît avoir pris connaissance des présentes CGU et les accepter sans réserve.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">2. Description du Service</h2>
            <p className="mb-3">DevisFast est une application SaaS mobile-first destinée aux artisans et auto-entrepreneurs français. Elle permet de :</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Créer et gérer des devis professionnels</li>
              <li>Créer et gérer des factures</li>
              <li>Gérer un catalogue de prestations</li>
              <li>Gérer une base de données clients</li>
              <li>Générer des documents PDF conformes à la réglementation française</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">3. Accès au Service</h2>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">3.1 Inscription</h3>
            <p>L'accès au Service nécessite la création d'un compte utilisateur. L'utilisateur s'engage à fournir des informations exactes, complètes et à jour lors de son inscription.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">3.2 Identifiants</h3>
            <p>L'utilisateur est seul responsable de la confidentialité de ses identifiants de connexion. Toute utilisation du Service avec ses identifiants est réputée effectuée par l'utilisateur lui-même.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">3.3 Essai gratuit</h3>
            <p>Un essai gratuit de 14 jours est proposé sans engagement et sans saisie de coordonnées bancaires. À l'issue de cette période, l'accès au Service est conditionné à la souscription d'un abonnement payant.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">4. Abonnement et tarification</h2>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">4.1 Tarif</h3>
            <p>Après la période d'essai gratuit de 14 jours, le Service est proposé selon deux formules : <strong className="text-foreground">9,99 € TTC par mois</strong> (renouvellement mensuel automatique) ou <strong className="text-foreground">89 € TTC par an</strong> (renouvellement annuel automatique), sous réserve de modification tarifaire.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">4.2 Paiement</h3>
            <p>Le paiement est effectué par carte bancaire via la plateforme sécurisée Stripe. L'abonnement est renouvelé automatiquement à chaque échéance (mensuelle ou annuelle selon la formule choisie) sauf résiliation.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">4.3 Résiliation</h3>
            <p>L'utilisateur peut résilier son abonnement à tout moment depuis son espace personnel, sans frais. La résiliation prend effet à la fin de la période en cours. Aucun remboursement partiel ne sera effectué.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">5. Obligations de l'utilisateur</h2>
            <p className="mb-3">L'utilisateur s'engage à :</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Utiliser le Service conformément à sa destination et aux lois en vigueur</li>
              <li>Ne pas utiliser le Service à des fins frauduleuses ou illicites</li>
              <li>Ne pas tenter de perturber ou compromettre le fonctionnement du Service</li>
              <li>Ne pas reproduire, copier, vendre ou exploiter tout ou partie du Service sans autorisation</li>
              <li>Respecter les droits des tiers, notamment en matière de propriété intellectuelle</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">6. Données et confidentialité</h2>
            <p>Les données saisies par l'utilisateur dans DevisFast lui appartiennent. ZANATTA CONSULTING s'engage à ne pas les céder à des tiers sans consentement préalable. En cas de résiliation, les données sont conservées pendant 90 jours avant suppression définitive, sauf demande expresse de l'utilisateur.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">7. Disponibilité du Service</h2>
            <p>ZANATTA CONSULTING s'efforce d'assurer la disponibilité du Service 24h/24 et 7j/7. Des interruptions pour maintenance ou en cas de force majeure peuvent survenir. ZANATTA CONSULTING ne saurait être tenu responsable des préjudices résultant d'une indisponibilité temporaire du Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">8. Propriété intellectuelle</h2>
            <p>DevisFast, son interface, son code source, ses algorithmes et ses contenus sont la propriété exclusive de ZANATTA CONSULTING et sont protégés par les lois sur la propriété intellectuelle. L'utilisateur bénéficie d'un droit d'utilisation personnel, non exclusif et non transférable.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">9. Responsabilité</h2>
            <p>ZANATTA CONSULTING ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du Service. L'utilisateur est seul responsable de la conformité de ses devis et factures avec la réglementation applicable à son activité.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">10. Modification des CGU</h2>
            <p>ZANATTA CONSULTING se réserve le droit de modifier les présentes CGU à tout moment. L'utilisateur sera informé de toute modification par email. L'utilisation du Service après modification vaut acceptation des nouvelles CGU.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">11. Droit applicable et litiges</h2>
            <p>Les présentes CGU sont soumises au droit français. En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux compétents du ressort de Toulouse seront saisis.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">12. Contact</h2>
            <p>Pour toute question relative aux CGU : support@devisfast.fr</p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-center text-sm text-muted-foreground">
          Dernière mise à jour : 04/05/2026
        </div>
      </div>
    </div>
  );
};

export default CGUPage;
